// Subdomains that are NOT brokers · they're reserved for the platform
// (admin panel, marketing, API). The detector returns null for these so
// the apex landing renders instead of trying to fetch a broker named "admin".
const RESERVED_SUBDOMAINS = new Set(['www', 'admin', 'api', 'app', 'painel', 'auth']);

/**
 * Detect the broker's subdomain in both prod and dev.
 *
 *   Production:           angel.dominio.com.br      → "angel"
 *   Dev *.localhost:      angel.localhost           → "angel"
 *   Dev query fallback:   ?broker=angel             → "angel"
 *   Apex / "www" / "admin" / plain localhost        → null
 */
export function detectSubdomain(): string | null {
  const url = new URL(window.location.href);
  const queryOverride = url.searchParams.get('broker');
  if (queryOverride) return queryOverride.toLowerCase();

  const host = url.hostname.toLowerCase();

  if (host === 'localhost' || host === '127.0.0.1') return null;

  if (host.endsWith('.localhost')) {
    const sub = host.slice(0, -'.localhost'.length);
    if (!sub || RESERVED_SUBDOMAINS.has(sub)) return null;
    return sub;
  }

  const base = (import.meta.env.VITE_PUBLIC_BASE_DOMAIN ?? '').toLowerCase();
  if (base && host.endsWith(`.${base}`)) {
    const sub = host.slice(0, host.length - base.length - 1);
    if (!sub || RESERVED_SUBDOMAINS.has(sub)) return null;
    return sub;
  }

  return null;
}
